import { Box, Heading, useToast, VStack } from "@chakra-ui/react";
import { Host } from "@olagg/db-types";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../consts/routes";
import HostForm from "./components/HostForm";
import useHosts from "./hooks/useHosts";

const CreateHost = () => {
    const { createHost } = useHosts();
    const toast = useToast();
    const navigate = useNavigate();

    const onSubmit = (data: Partial<Host>) => {
        createHost(data)
            .then(() => {
                toast({
                    title: 'Host',
                    colorScheme: 'olaggPink',
                    status: 'success',
                    description: `Host creado con éxito`,
                    position: 'bottom-right'
                });
                navigate(ROUTES.EVENTS.all);
                setTimeout(() => {
                    window.location.reload();
                }, 100);
            })
            .catch((error: Error) => {
                toast({
                    title: 'Error',
                    colorScheme: 'olaggYellow',
                    status: 'error',
                    description: error.message,
                    position: 'bottom-right'
                });
            })
    }

    return (
        <Box w={'full'} pb={4} minH='600px'>
            <VStack color={'white'} w={'full'}>
                <Heading my={2}>Crear host</Heading>
                <HostForm onSubmit={onSubmit} />
            </VStack>
        </Box>
    )
};

export default CreateHost;